import { ContextClassBase } from '../../core/service/RuntimeContext.js';

var IMRtcEvent;
(function (IMRtcEvent) {
    IMRtcEvent["StreamPublished"] = "stream-published";
    IMRtcEvent["StreamAdded"] = "stream-added";
    IMRtcEvent["StreamSubscribed"] = "stream-subscribed";
    IMRtcEvent["StreamRemoved"] = "stream-removed";
    IMRtcEvent["MuteAudio"] = "mute-audio";
    IMRtcEvent["UnmuteAudio"] = "unmute-audio";
    IMRtcEvent["MuteVideo"] = "mute-video";
    IMRtcEvent["UnmuteVideo"] = "unmute-video";
    IMRtcEvent["ClientBanned"] = "client-banned";
    IMRtcEvent["PeerOnline"] = "peer-online";
    IMRtcEvent["PeerLeave"] = "peer-leave";
    IMRtcEvent["TokenRequest"] = "token-request";
    IMRtcEvent["CameraChanged"] = "camera-changed";
    IMRtcEvent["RecordingDeviceChanged"] = "recording-device-changed";
    IMRtcEvent["PlayoutDeviceChanged"] = "playout-device-changed";
    IMRtcEvent["ConnectionStateChange"] = "connection-state-change";
    IMRtcEvent["NetworkTypeChanged"] = "network-type-changed";
})(IMRtcEvent || (IMRtcEvent = {}));
class IMRtcStream extends ContextClassBase {
}
class IMRtcApi extends ContextClassBase {
}
class IMRtcClient extends ContextClassBase {
}

export { IMRtcApi, IMRtcClient, IMRtcEvent, IMRtcStream };
//# sourceMappingURL=IMRtcApi.js.map
